"use client";

import { useUniqueId } from "@faire/react/hooks/useUniqueId";
import { cn } from "@faire/react/tools/cn";
import { parseUnit } from "@faire/react/tools/styleUtils";
import React from "react";

import "./native-styles.css";
import { SVGIconProps } from "./types";

// NOTE: We can't use tailwind for icon yet because icons are used in several projects where tailwind hasn't been configured
export const SVGIcon: React.FC<
  SVGIconProps & React.RefAttributes<SVGElement>
> = ({
  children,
  className,
  titleAccess,
  viewBox,
  ref,
  width,
  height,
  margin,
  fontSize,
  color,
  fill,
  style,
  component,
  ...rest
}) => {
  const labelId = useUniqueId("titleAccess-");

  const Component = component ?? "svg";
  const vars: Record<string, string> = {};

  if (color) {
    vars["--f-svg-color"] = color;
  }
  if (fill) {
    vars["--f-svg-fill"] = fill;
  }
  if (width) {
    vars["--f-svg-width"] = parseUnit(width);
  }
  if (height) {
    vars["--f-svg-height"] = parseUnit(height);
  }
  if (margin) {
    vars["--f-svg-margin"] = margin;
  }

  if (fontSize !== undefined) {
    vars["--f-svg-font-size"] = parseUnit(fontSize.toString());
  }

  return (
    <Component
      ref={ref}
      className={cn("svgicon", className, {
        "svgicon-font-size": fontSize !== undefined,
      })}
      focusable="false"
      viewBox={viewBox ?? "0 0 24 24"}
      aria-labelledby={titleAccess ? labelId : undefined}
      aria-hidden={titleAccess ? undefined : "true"}
      role={titleAccess ? "img" : "presentation"}
      style={{
        ...vars,
        ...style,
      }}
      {...rest}
    >
      {children}
      {titleAccess ? <title id={labelId}>{titleAccess}</title> : null}
    </Component>
  );
};
